<template>
  <div
    class="accessory"
    id="wrap"
    style="margin-top: 10px; padding: 20px 30px"
    v-loading="loading"
  >
    <p class="txt">附件格式要求(营业执照除外):</p>
    <p class="txt">1、证明材料扫描上传</p>
    <p class="txt">2、只支持非加密PDF格式的文件上传</p>
    <p class="txt">3、单个文件大小不要超过3M</p>
    <div class="item">
      <p class="text">
        1、营业执照(图片或pdf)
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before5Upload"
        :on-success="quillImgSuccess"
        :on-remove="handleRemove"
        :on-preview="handleView"
        :on-error="uploadError"
        :data="{'moduleType': 22}"
        :file-list="yFileList"
        accept="application/pdf,.png,.jpeg,.jpg"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="txt">说明:请上传加盖公章的营业执照扫描件,大小不超过500KB</p>
    </div>
    <div class="item">

      <p class="text">
        2、申请书封皮
      </p>

      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 23}"
        multiple
        :file-list="sfpFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="txt">说明:请上传系统自动生成的申请书封皮盖章后的扫描件</p>
    </div>
    <div class="item">
      <p class="text">
        3、近三年财务审计报告
      </p>
      <p class="title flex flex-justify" style="margin-left: 20px">
        <span>{{ sjYears[0] }}</span>
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 24}"
        multiple
        :file-list="cwsjOneFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>

      <p class="title flex flex-justify" style="margin-left: 20px">
        <span>{{ sjYears[1] }}</span>
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 25}"
        multiple
        :file-list="cwsjTwoFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>

      <p class="title flex flex-justify" style="margin-left: 20px">
        <span>{{ sjYears[2] }}</span>
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 26}"
        multiple
        :file-list="cwsjThreeFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="txt">说明:请上传系统自动生成的申请书封皮盖章后的扫描件</p>
    </div>

    <div class="item">
      <p class="text">
        4、近一年高新产品(服务)收入专项审计报告
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 27}"
        multiple
        :file-list="srzxsjFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>

      <p class="txt">
        请上传具有资质并服务《工作指引》相关条件的中介结构出具的企业近一个会计年度高新技术产品(服务)收入专项审计或鉴证报告。
      </p>
    </div>

    <div class="item">
      <p class="text">5、近三年企业所得纳税申报表</p>
      <p class="title flex flex-justify" style="margin-left: 20px">
        <span>{{ nssbYears[0] }}</span>
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 28}"
        multiple
        :file-list="nssbOneFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="title flex flex-justify" style="margin-left: 20px">
        <span>{{ nssbYears[1] }}</span>
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 29}"
        multiple
        :file-list="nssbTwoFileList"
        accept="application/pdf"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="title flex flex-justify" style="margin-left: 20px">
        <span>{{ nssbYears[2] }}</span>
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        accept="application/pdf"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 30}"
        multiple
        :file-list="nssbThreeFileList"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="txt">
        请上传企业近三个会计年度实际年限不足三年的按照实际经营年限)企业所得税年度纳税申报表(包括主表及附表)
      </p>
    </div>
    <div class="item">
      <p class="text">
        6、近三年研发费用专项审计报告
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        accept="application/pdf"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 31}"
        multiple
        :file-list="zxsjFileList"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
      <p class="txt">
        请上传经具有资质并符合《工作指引》相关条件的中介机构出具的企业近三个会计年度(实际年限不足三年的按照实经营年限)研究开发费用专项审计或鉴证报告(并附研究开发活动说明材料)
      </p>

    </div>
    <div class="item">
      <p class="text">
        7、认定机构要求上传的其他附件
      </p>
      <el-upload
        class="upload-demo"
        :action="uploadImgUrl"
        accept="application/pdf"
        :before-upload="before3Upload"
        :on-success="quillImgSuccess"
        :on-preview="handleView"
        :on-remove="handleRemove"
        :on-error="uploadError"
        :data="{'moduleType': 32}"
        multiple
        :file-list="qtfjFileList"
      >
        <el-button size="small" type="primary"
        ><i class="el-icon-upload"></i> 上传</el-button
        >
      </el-upload>
    </div>
  </div>
</template>

<script>
import { commonFileGetMultiFiles, commonFileSaveFile } from '@/api/ChinaHigh'
import { getLastThreeYears } from '@/api/specialization'
export default {
  name: "accessory",
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
        loading:false,
      yFileList: [],
      // 封皮
      sfpFileList: [],
      // 近三年财务审计报告
      cwsjOneFileList: [],
      cwsjTwoFileList: [],
      cwsjThreeFileList: [],
      //近一年高新产品(服务)收入专项审计报告
      srzxsjFileList: [],
      // 近三年企业所得纳税申报表
      nssbOneFileList: [],
      nssbTwoFileList: [],
      nssbThreeFileList: [],
      // 近三年研发费用专项审计报告
      zxsjFileList: [],
      // 认定机构要求上传的其他附件
      qtfjFileList: [],
      sjYears: [],
      nssbYears: []
    }
  },
  created() {
    this.chushi();
  },
  methods: {
    chushi() {
      getLastThreeYears().then(res => {
        this.sjYears = [ res.data[0] + '财务审计报告', res.data[1] + '财务审计报告', res.data[2] + '财务审计报告'];
        this.nssbYears = [ res.data[0] + '企业所得纳税申报表', res.data[1] + '企业所得纳税申报表', res.data[2] + '企业所得纳税申报表'];
      })
      commonFileGetMultiFiles({'moduleId': this.id, 'moduleTypes': [22,23,24,25,26,27,28,29,30,31,32]}).then(res => {
        res.data.forEach(data => {
          this.typeData({"name": data.fileName, "fileName": data.fileName, "url": data.url, "moduleId": data.moduleId, "moduleType": data.moduleType, "path": data.path, 'id': data.id}, (r)=>{})
        })
      })
    },
    typeData(data, callback) {
      var list = [];
      var datas = {"name": data.fileName, "fileName": data.fileName, "url": data.url, "moduleId": data.moduleId, "moduleType": data.moduleType, "path": data.path, 'id': data.id};
      var type = data.moduleType;
      if(type == 22) {
        this.yFileList.push(datas);
        list = this.yFileList;
      }
      if(type == 23) {
        this.sfpFileList.push(datas)
        list = this.sfpFileList;
      }
      if(type == 24) {
        this.cwsjOneFileList.push(datas)
        list = this.cwsjOneFileList;
      }
      if(type == 25) {
        this.cwsjTwoFileList.push(datas)
        list = this.cwsjTwoFileList;
      }
      if(type == 26) {
        this.cwsjThreeFileList.push(datas)
        list = this.cwsjThreeFileList;
      }
      if(type == 27) {
        this.srzxsjFileList.push(datas)
        list = this.srzxsjFileList;
      }
      if(type == 28) {
        this.nssbOneFileList.push(datas)
        list = this.nssbOneFileList;
      }
      if(type == 29) {
        this.nssbTwoFileList.push(datas)
        list = this.nssbTwoFileList;
      }
      if(type == 30) {
        this.nssbThreeFileList.push(datas)
        list = this.nssbThreeFileList;
      }
      if(type == 31) {
        this.zxsjFileList.push(datas)
        list = this.zxsjFileList;
      }
      if(type == 32) {
        this.qtfjFileList.push(datas)
        list = this.qtfjFileList;
      }
      callback(list);
    },
    // 上传成功
    quillImgSuccess(res, file) {
        this.loading=false;
      // 如果上传成功
      if (res.code === '00000') {
        this.typeData(Object.assign({},res.data, {'moduleId': this.id}), (data) => {
          this.shanchu(data);
        })
        this.msgSuccess("附件上传成功");
      } else {
        this.msgError("附件上传失败");
      }
    },
    // 图片删除

    handleRemove(file, fileList) {
      var list = []
        if(file.status == "success") {
            fileList.forEach(res => {
                if (res.response == undefined) {
                    list.push(res);
                } else {
                    list.push(res.response.data);
                }
            })
            if (list.length <= 0) {
                this.shanchu([{"moduleType": file.moduleType, "moduleId": this.id}])
            } else {
                this.shanchu(list);
            }
        }
    },
    // 富文本图片上传失败
    uploadError() {
        this.loading=false;
      // loading动画消失
      this.msgError("图片上传失败");
    },
      beforeUpload(file) {
          var testmsg = file.name.substring(file.name.lastIndexOf('.')+1);
          const extension = testmsg === 'pdf';
          const isLt2M = file.size / 1024 /1024 <= 4;
          if(!extension) {
              this.msgError('上传文件只能是pdf文件');
          }
          this.loading=true;

          return extension;
      },
      before5Upload(file) {
          let suffix=file.name.substring(file.name.lastIndexOf(".")+1);
          if (suffix!='pdf'&&suffix!='jpg'&&suffix!='png'&&suffix!='jpeg'){
              this.msgError("只能上传pdf/jpg/png格式的文件");
              return false;
          }
          if (file.size>1024*500){
              this.msgError("文件不能超过500KB");
              return false;
          }
          // this.loading=true;
/*        var testmsg = file.name.substring(file.name.lastIndexOf('.')+1);
          const extension = testmsg === 'pdf'||'jpg'||'png'||'jpeg';
          const isLt2M = file.size / 1024 /1024 <= 3;
          if(!extension) {
              this.msgError('上传文件只能是pdf,jpg,png文件');
              return false;
          }

          if(!isLt2M) {
              this.msgError('上传文件大小不能超过3M');
              return false;
          }

          return extension && isLt2M;*/
      },
      before3Upload(file) {
          var testmsg = file.name.substring(file.name.lastIndexOf('.')+1);
          const extension = testmsg === 'pdf';
          const isLt2M = file.size / 1024 /1024 <= 3;
          if(!extension) {
              this.msgError('上传文件只能是pdf文件');
          }

          if(!isLt2M) {
              this.msgError('上传文件大小不能超过3M');
          }
          // this.loading=true;
          return extension && isLt2M;
      },
    shanchu(data) {
      commonFileSaveFile(data).then( re => {
      })
    }
  }
}
</script>

<style scoped>
.txt {
  margin-left: 20px;
  font-size: 13px;
  color: #666;
}
.flex .el-button {
  margin-bottom: 10px;
}
.upload-demo{
  width: 100%;
  margin-bottom: 50px;
  display: flex;
  flex-wrap: wrap;
}
.el-upload{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.text {
  font-size: 14px;
  padding: 10px 20px;
  position: relative;
  border-bottom: 1px solid #dbdbdb;
}
.text::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 18px;
  left: 10px;
  top: 10px;
  background: #7c99fd;
}
.title{
  font-size: 14px;
}

</style>
